export var FirstRunStorageKey = 'FirstRunState';
export var SecondRunStorageKey = 'SecondRunState';
export var TuiNewUserStorageKey = 'TuiNewUserState';
export var LegacyStorageKey = 'FirstRunData';
export var LocalLegacyStorageKey = '_' + LegacyStorageKey;
export var UserStoragePersistenceVersion = 1;
//# sourceMappingURL=Constants.js.map